export default "__VITE_ASSET__CgX7PMh9__"